/* WeAreOne Wardrobe, Station 3 home build.
   Behaviour carried from the locked prototype v2: mega menu, drawer,
   language and country panels, toast, Halloween 2026 countdown.
   Idempotent: safe to load from more than one section. */
(function () {
  if (window.__w1) return;
  window.__w1 = true;

  var toastTimer;
  window.w1Toast = function (msg) {
    var t = document.getElementById('w1Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  window.w1OpenMega = function () {
    if (window.__w1TourActive) return; /* hover must not open it under the tour dim; a real click closes the tour first, then opens it clean */
    var m = document.getElementById('w1Mega');
    if (m) m.classList.add('open');
  };
  window.w1CloseMega = function () { var m = document.getElementById('w1Mega'); if (m) m.classList.remove('open'); };
  window.w1OpenDrawer = function () {
    var d = document.getElementById('w1Drawer'), s = document.getElementById('w1Scrim');
    if (d) d.classList.add('open');
    if (s) s.classList.add('open');
  };
  window.w1CloseDrawer = function () {
    var d = document.getElementById('w1Drawer'), s = document.getElementById('w1Scrim');
    if (d) d.classList.remove('open');
    if (s) s.classList.remove('open');
  };
  window.w1ToggleLangs = function () {
    var p = document.getElementById('w1LangPanel'), c = document.getElementById('w1CountryPanel');
    if (p) p.classList.toggle('open');
    if (c) c.classList.remove('open');
  };
  window.w1ToggleCountry = function () {
    var p = document.getElementById('w1CountryPanel'), c = document.getElementById('w1LangPanel');
    if (p) p.classList.toggle('open');
    if (c) c.classList.remove('open');
  };
  window.w1SetCountry = function (el, word, cur) {
    document.querySelectorAll('#w1CountryPanel button').forEach(function (b) { b.classList.remove('on'); });
    el.classList.add('on');
    document.querySelectorAll('.curword').forEach(function (e) { e.textContent = word; });
    window.w1Toast('Prices switch to ' + cur + ' with live rates at the store build');
  };

  /* build-your-own tray, tiers named only, percentages hidden */
  window.w1PickTile = function (el) {
    el.classList.toggle('picked');
    var n = document.querySelectorAll('.tile.picked').length;
    var c = document.getElementById('w1TrayCount');
    if (c) c.textContent = n;
    var t = document.getElementById('w1TrayTier');
    if (t) t.textContent = n >= 4 ? 'The Family Pack' : n === 3 ? 'The Trio' : n === 2 ? 'The Duo' : 'Add 2+ to unlock The Duo';
  };
  window.w1AddTray = function () {
    var n = document.querySelectorAll('.tile.picked').length;
    if (n < 1) { window.w1Toast('Pick some pieces first'); return; }
    window.w1Toast('Sets go live with the products, one cart across all six worlds');
  };

  /* PDP helpers */
  window.w1SelThumb = function (el, t) {
    document.querySelectorAll('#w1Gthumbs .shot').forEach(function (s) { s.classList.remove('sel'); });
    el.classList.add('sel');
    var g = document.getElementById('w1GmainTag');
    if (g) g.textContent = t;
  };
  window.w1SelMedia = function (el, src) {
    document.querySelectorAll('#w1Gthumbs .shot').forEach(function (s) { s.classList.remove('sel'); });
    el.classList.add('sel');
    var img = document.getElementById('w1GmainImg');
    if (img) img.src = src;
  };
  window.w1SelOne = function (el, sel) {
    document.querySelectorAll(sel).forEach(function (s) { s.classList.remove('sel'); });
    el.classList.add('sel');
  };

  /* PDP variant engine: reads the product JSON island, resolves the
     colour + size pair to a variant, keeps price, BNPL, stock line,
     URL and the add-to-cart form in step. Money is rendered as
     A$<dollars> to match the locked prototype format (AUD launch). */
  function w1Money(cents) {
    return 'A$' + (cents / 100).toFixed(2);
  }
  function w1ProductData() {
    var el = document.getElementById('w1ProductData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* 2026-08-20. The pick used to be two named things, colour and size, and
     the matcher compared them to option1 and option2 by assumption. That is
     why a product with Design, Size, Paper and Quantity could not work: the
     third and fourth options had nowhere to go, and Design would have been
     read as a colour. The pick is now whatever is selected, keyed by the
     option's POSITION, so any number of options in any order resolves. */
  function w1CurrentPick() {
    var byPos = {};
    document.querySelectorAll('[data-opt-pos][data-opt-value].sel').forEach(function (el) {
      byPos[el.getAttribute('data-opt-pos')] = el.getAttribute('data-opt-value');
    });
    var c = document.querySelector('.swatchbig .sw.sel');
    return {
      byPos: byPos,
      colour: c ? c.getAttribute('data-colour') : null,
      hex: c ? c.getAttribute('data-hex') : null
    };
  }
  function w1SyncVariant() {
    var data = w1ProductData();
    if (!data) return;
    var pick = w1CurrentPick();
    /* Match on every selected option by position. A variant qualifies only
       if it agrees with all of them, so nothing is decided by option order. */
    var match = data.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      for (var pos in pick.byPos) {
        if (opts[Number(pos) - 1] !== pick.byPos[pos]) return false;
      }
      return true;
    });
    /* Nothing agrees with the whole pick, usually a combination that was
       never created. Fall back to the closest available variant rather than
       leaving the buy button pointing at the old one. */
    if (!match) {
      match = data.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        var hits = 0;
        for (var pos in pick.byPos) { if (opts[Number(pos) - 1] === pick.byPos[pos]) hits++; }
        return hits > 0 && v.available;
      });
    }
    if (!match) return;
    var idEl = document.getElementById('w1VariantId');
    if (idEl) idEl.value = match.id;
    var price = document.getElementById('w1Price');
    if (price) price.textContent = w1Money(match.price);
    var bnpl = document.getElementById('w1Bnpl');
    if (bnpl) bnpl.textContent = w1Money(Math.round(match.price / 4));
    var btn = document.getElementById('w1AtcBtn');
    if (btn) btn.textContent = match.available ? 'Add to cart · ' + w1Money(match.price) : 'Out of stock';
    if (btn) btn.disabled = !match.available;
    var stock = document.getElementById('w1Stock');
    if (stock) stock.innerHTML = '<i></i> ' + (match.available ? 'In stock and ready to ship' : 'Out of stock right now');
    var notify = document.getElementById('w1Notify');
    if (notify) notify.hidden = match.available;
    var notifyTags = document.getElementById('w1NotifyTags');
    if (notifyTags) notifyTags.value = 'notify-restock,notify-variant-' + match.id;
    /* Swatch switches every image once real media lands: the mockup
       pipeline names alt text "<Colour> | <View>", thumbs filter to the
       picked colour, main takes the first match. */
    if (data.hasImages && pick.colour) {
      var thumbs = document.querySelectorAll('#w1Gthumbs .shot img');
      var first = null;
      thumbs.forEach(function (img) {
        var mine = (img.alt || '').toLowerCase().indexOf(pick.colour.toLowerCase()) === 0;
        img.parentElement.style.display = mine || !/\|/.test(img.alt || '') ? '' : 'none';
        if (mine && !first) first = img;
      });
      var main = document.getElementById('w1GmainImg');
      if (main && first) main.src = first.src.replace('width=200', 'width=1200');
    }
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }
  /* One handler for every option control. The group it belongs to is its own
     container, found from the control, so a new option type needs markup and
     nothing here. */
  window.w1PickOption = function (el) {
    /* The control carries data-opt-pos itself, so closest() from the element
       returns the element. Start from its parent to reach the group. */
    var group = el.parentElement ? el.parentElement.closest('[data-opt-pos]') : null;
    if (group) {
      group.querySelectorAll('[data-opt-value]').forEach(function (o) {
        var on = o === el;
        o.classList.toggle('sel', on);
        if (o.hasAttribute('aria-checked')) o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    if (el.classList.contains('sw')) w1ApplyColour(el);
    var dn = document.getElementById('w1DesignName');
    if (dn && el.classList.contains('designcard')) dn.textContent = el.getAttribute('data-opt-value');
    w1SyncVariant();
  };
  function w1ApplyColour(el) {
    var name = el.getAttribute('data-colour');
    var hex = el.getAttribute('data-hex');
    var label = document.getElementById('w1ColourName');
    if (label) label.textContent = name;
    var data = w1ProductData();
    if (data && !data.hasImages) {
      var main = document.getElementById('w1Gmain');
      if (main) main.style.background = 'color-mix(in srgb, ' + hex + ' 46%, #F6F3EE)';
      var gc = document.getElementById('w1GmainColour');
      if (gc) gc.textContent = name;
    }
  }
  /* Kept so anything still calling the old names keeps working. */
  window.w1PickColour = function (el) { window.w1PickOption(el); };
  window.w1PickSize = function (el) { window.w1PickOption(el); };
  /* The buy column adds to cart through fetch, so nothing reaches Shopify
     unless this function carries it. Product app blocks (Printify's
     Personalize Button) hand the buyer's personalisation over as extra
     inputs, usually properties[...], and a hand-built {id, quantity} body
     drops every one of them: the order then arrives blank. So serialise
     the form itself, plus any named input an app renders outside the form,
     and post the lot as form data. Form data also keeps file inputs whole,
     which JSON cannot. */
  function w1AtcPayload(form) {
    var fd = new FormData(form);
    var seen = [];
    var extras = [];
    var box = document.getElementById('w1AppBlocks');
    if (box) extras = extras.concat(Array.prototype.slice.call(box.querySelectorAll('input[name],select[name],textarea[name]')));
    /* An app may inject its line item properties anywhere on the page,
       so sweep for them by name as well. */
    extras = extras.concat(Array.prototype.slice.call(document.querySelectorAll('[name^="properties["]')));
    extras.forEach(function (el) {
      if (el.form === form || el.disabled || seen.indexOf(el) > -1) return;
      seen.push(el);
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.type === 'file') {
        for (var i = 0; i < el.files.length; i++) fd.append(el.name, el.files[i]);
        return;
      }
      fd.append(el.name, el.value);
    });
    return fd;
  }
  window.w1AtcPayload = w1AtcPayload;
  function w1WireAtc() {
    var form = document.getElementById('w1AtcForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('w1AtcBtn');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: w1AtcPayload(form)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        return fetch('/cart.js').then(function (c) { return c.json(); });
      }).then(function (cart) {
        document.querySelectorAll('a.cart .count').forEach(function (n) { n.textContent = cart.item_count; n.setAttribute('data-n', cart.item_count); });
        if (btn) { btn.textContent = 'Added ✓'; btn.disabled = false; }
        window.w1Toast('In your bag. One cart across all six worlds.');
        setTimeout(w1SyncVariant, 1600);
      }).catch(function (err) {
        if (btn) { btn.disabled = false; }
        w1SyncVariant();
        window.w1Toast(err.message);
      });
    });
  }

  /* Search suite: predictive overlay on /search/suggest.json with
     product thumbnails, category suggestions and popular searches. */
  var suggestTimer;
  window.w1OpenSearch = function () {
    var s = document.getElementById('w1Search');
    if (!s) return;
    s.classList.add('open');
    document.body.style.overflow = 'hidden';
    var i = document.getElementById('w1SearchInput');
    if (i) setTimeout(function () { i.focus(); }, 60);
  };
  window.w1CloseSearch = function () {
    var s = document.getElementById('w1Search');
    if (!s) return;
    s.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.w1SearchGo = function (form) {
    var q = form.querySelector('input[name="q"]').value.trim();
    if (!q) return false;
    window.location.href = form.action + '?q=' + encodeURIComponent(q);
    return false;
  };
  window.w1Suggest = function (q) {
    clearTimeout(suggestTimer);
    var box = document.getElementById('w1SearchProducts');
    if (!box) return;
    if (!q || q.trim().length < 2) {
      box.innerHTML = '<h5>Pieces</h5><div class="ssempty">Start typing and the wardrobe answers: pieces, colours, sets.</div>';
      return;
    }
    suggestTimer = setTimeout(function () {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q.trim()) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var res = data.resources.results;
        var products = res.products || [];
        var cols = res.collections || [];
        var queries = res.queries || [];
        var html = '<h5>Pieces</h5>';
        if (!products.length) {
          html += '<div class="ssempty">No piece answers to that yet. Try a colour, a garment or a collection.</div>';
        } else {
          html += products.map(function (p) {
            var iu = p.featured_image && p.featured_image.url;
            var img = iu
              ? '<img src="' + iu + (iu.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="60" height="80" loading="lazy">'
              : '<span class="ssbox"></span>';
            return '<a class="ssitem" href="' + p.url + '">' + img +
              '<span><b>' + p.title + '</b><small>' + (p.price ? 'A$' + p.price : '') + '</small></span></a>';
          }).join('');
        }
        if (queries.length) {
          html += '<div class="sschips">' + queries.map(function (s) {
            return '<a class="chip filter" href="/search?q=' + encodeURIComponent(s.text) + '">' + s.styled_text + '</a>';
          }).join('') + '</div>';
        }
        box.innerHTML = html;
        var cats = document.getElementById('w1SearchCats');
        if (cats && cols.length) {
          cats.innerHTML = '<h5>Categories</h5><div class="sslinks">' + cols.map(function (c) {
            return '<a href="' + c.url + '">' + c.title + '</a>';
          }).join('') + '</div>';
        }
      }).catch(function () { /* network hiccup: keep the last state */ });
    }, 220);
  };

  /* Quick Add on cards: size row opens, one tap adds the lead-colour
     variant through the same cart path as the PDP. */
  window.w1QuickOpen = function (btn) {
    document.querySelectorAll('.qa-sizes').forEach(function (s) { s.hidden = true; });
    var sizes = btn.parentElement.querySelector('.qa-sizes');
    if (sizes) sizes.hidden = false;
  };
  window.w1QuickAdd = function (btn, variantId) {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add that'); });
      return fetch('/cart.js').then(function (c) { return c.json(); });
    }).then(function (cart) {
      document.querySelectorAll('a.cart .count').forEach(function (n) { n.textContent = cart.item_count; n.setAttribute('data-n', cart.item_count); });
      btn.disabled = false;
      btn.closest('.qa-sizes').hidden = true;
      window.w1Toast('In your bag. One cart across all six worlds.');
    }).catch(function (err) {
      btn.disabled = false;
      window.w1Toast(err.message);
    });
  };

  /* Price bands: client-side over data-price until Search & Discovery
     is configured. State carried in ?price=min-max. */
  function w1ApplyPriceBand(min, max, label) {
    var grid = document.getElementById('w1Grid');
    if (!grid) return;
    var misses = 0;
    grid.querySelectorAll('.pcard-live').forEach(function (card) {
      var p = parseInt(card.getAttribute('data-price'), 10);
      var hit = isNaN(p) || (p >= min && p < max);
      card.style.display = hit ? '' : 'none';
      if (!hit) misses++;
    });
    var active = document.getElementById('w1PriceActive');
    var chipTxt = document.getElementById('w1PriceActiveChip');
    if (active && chipTxt) {
      active.hidden = false;
      chipTxt.textContent = label + ' ✕';
    }
    var none = document.getElementById('w1NoMatch');
    if (none) none.hidden = grid.querySelectorAll('.pcard-live:not([style*="none"])').length > 0;
  }
  window.w1PriceBand = function (btn) {
    var min = parseInt(btn.getAttribute('data-min'), 10);
    var max = parseInt(btn.getAttribute('data-max'), 10);
    document.querySelectorAll('.pricechip').forEach(function (c) { c.classList.remove('on'); });
    btn.classList.add('on');
    var url = new URL(window.location.href);
    url.searchParams.set('price', min + '-' + max);
    window.history.replaceState({}, '', url);
    w1ApplyPriceBand(min, max, btn.textContent.trim());
  };
  window.w1PriceClear = function () {
    document.querySelectorAll('.pricechip').forEach(function (c) { c.classList.remove('on'); });
    var url = new URL(window.location.href);
    url.searchParams.delete('price');
    window.history.replaceState({}, '', url);
    var grid = document.getElementById('w1Grid');
    if (grid) grid.querySelectorAll('.pcard-live').forEach(function (card) { card.style.display = ''; });
    var active = document.getElementById('w1PriceActive');
    if (active) active.hidden = true;
    var none = document.getElementById('w1NoMatch');
    if (none) none.hidden = true;
  };
  function w1RestorePriceBand() {
    var m = new URLSearchParams(window.location.search).get('price');
    if (!m) return;
    var parts = m.split('-');
    var chip = document.querySelector('.pricechip[data-min="' + parts[0] + '"][data-max="' + parts[1] + '"]');
    if (chip) {
      chip.classList.add('on');
      w1ApplyPriceBand(parseInt(parts[0], 10), parseInt(parts[1], 10), chip.textContent.trim());
    }
  }

  /* Sort keeps the tag path, swaps the sort_by param. */
  window.w1Sort = function (v) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', v);
    window.location.href = url.toString();
  };

  /* Welcome pop-up: never instant on landing. Four seconds on the page
     minimum, then 30 per cent scroll or a 14-second timer, whichever
     first. Once per browser, skipped on cart, checkout and policies. */
  function w1WelcomeInit() {
    var el = document.getElementById('w1Welcome');
    if (!el) return;
    var path = window.location.pathname;
    if (/\/cart|\/checkouts|\/policies|\/challenge/.test(path)) return;
    try { if (localStorage.getItem('w1_welcome_done')) return; } catch (e) { return; }
    var armed = false, shown = false;
    function show() {
      if (shown || !armed) return;
      if (window.__w1TourActive) return; /* never pop over the guided tour */
      shown = true;
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('open'); });
    }
    setTimeout(function () { armed = true; }, 4000);
    setTimeout(function () { armed = true; show(); }, 14000);
    /* Horizon scrolls the .page-wrapper container on desktop, the
       window on mobile: watch both. */
    function depthOf(el) {
      if (el === window || el === document) {
        var h = document.documentElement;
        return (h.scrollTop + window.innerHeight) / Math.max(1, h.scrollHeight);
      }
      return (el.scrollTop + el.clientHeight) / Math.max(1, el.scrollHeight);
    }
    var roots = [window];
    var pw = document.querySelector('.page-wrapper');
    if (pw) roots.push(pw);
    roots.forEach(function (root) {
      root.addEventListener('scroll', function onScroll() {
        if (depthOf(root === window ? window : root) > 0.3) {
          root.removeEventListener('scroll', onScroll);
          show();
        }
      }, { passive: true });
    });
  }
  window.w1CloseWelcome = function () {
    var el = document.getElementById('w1Welcome');
    if (!el) return;
    el.classList.remove('open');
    setTimeout(function () { el.hidden = true; }, 260);
    try { localStorage.setItem('w1_welcome_done', '1'); } catch (e) { /* private mode */ }
  };

  /* Wishlist: native localStorage build wired to the header heart.
     Device-scoped for launch; Swym or the customer metafield takes
     over post re-auth without changing this surface. */
  function w1WishList() {
    try { return JSON.parse(localStorage.getItem('w1_wishlist') || '[]'); } catch (e) { return []; }
  }
  function w1WishSave(list) {
    try { localStorage.setItem('w1_wishlist', JSON.stringify(list.slice(0, 60))); } catch (e) { /* private mode */ }
    w1WishBadge();
  }
  function w1WishBadge() {
    var n = w1WishList().length;
    document.querySelectorAll('.wishcount').forEach(function (b) {
      b.textContent = n || '';
      b.style.display = n ? '' : 'none';
    });
  }
  window.w1WishToggle = function (el) {
    var handle = el.getAttribute('data-handle');
    var list = w1WishList();
    var i = list.findIndex(function (x) { return x.handle === handle; });
    if (i > -1) {
      list.splice(i, 1);
      el.textContent = '♡';
      window.w1Toast('Taken off your list');
    } else {
      list.unshift({ handle: handle, title: el.getAttribute('data-title'), price: el.getAttribute('data-price') });
      el.textContent = '♥';
      window.w1Toast('Saved to your list');
    }
    w1WishSave(list);
  };
  /* Flash-sale face in the wishlist (Brief 4 M5): live truth only. On
     open, each saved handle's /products/<handle>.js is read (120s
     session cache) for a flash-until: tag; items in a live flash sort
     first with the badge and their own countdown. The alert engine is
     launch prep (Klaviyo + wishlist sync), NOT built here: the line
     below the list says what favourites get, nothing sends. */
  function w1FlashUntil(tags) {
    for (var i = 0; i < (tags || []).length; i++) {
      if (tags[i].indexOf('flash-until:') === 0) {
        var t = Date.parse(tags[i].slice(12).trim());
        if (!isNaN(t)) return t;
      }
    }
    return 0;
  }
  function w1FlashLookup(handles) {
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('w1_flash_cache') || '{}'); } catch (e) { /* fresh */ }
    var now = Date.now();
    return Promise.all(handles.slice(0, 20).map(function (h) {
      var hit = cache[h];
      if (hit && now - hit.t < 120000) return Promise.resolve([h, hit.u]);
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return [h, p ? w1FlashUntil(p.tags) : 0]; })
        .catch(function () { return [h, 0]; });
    })).then(function (pairs) {
      var out = {};
      pairs.forEach(function (pr) { out[pr[0]] = pr[1]; cache[pr[0]] = { u: pr[1], t: now }; });
      try { sessionStorage.setItem('w1_flash_cache', JSON.stringify(cache)); } catch (e) { /* private mode */ }
      return out;
    });
  }
  function w1WishRender(panel, list, flash) {
    var body = panel.querySelector('.wp-body');
    if (!body) return;
    var now = Date.now();
    var live = [], rest = [];
    list.forEach(function (x) {
      var u = flash ? flash[x.handle] || 0 : 0;
      (u > now ? live : rest).push({ x: x, u: u });
    });
    live.sort(function (a, b) { return a.u - b.u; });
    var rows = live.concat(rest).map(function (it) {
      var x = it.x;
      var chip = it.u > now
        ? '<span class="wp-flash" data-flash-until="' + new Date(it.u).toISOString() + '">Flash sale · <span data-flash-text>live now</span></span>'
        : '';
      return '<a href="/products/' + x.handle + '"><span>' + x.title + chip + '</span><small>A$' + (Number(x.price) / 100).toFixed(2) + '</small></a>';
    });
    body.innerHTML = rows.length
      ? rows.join('')
      : '<p class="ssempty">Nothing saved yet. Tap the heart on any piece and it waits here.</p>';
    var note = panel.querySelector('.wp-alert');
    if (!note) {
      note = document.createElement('p');
      note.className = 'wp-alert';
      note.textContent = 'Favourites get flash-sale alerts';
      panel.appendChild(note);
    }
    w1FlashTick();
  }
  window.w1WishPanel = function () {
    var panel = document.getElementById('w1WishPanel');
    if (!panel) return;
    var opening = !panel.classList.contains('open');
    panel.classList.toggle('open');
    if (!opening) return;
    var list = w1WishList();
    w1WishRender(panel, list, null);
    if (list.length) {
      w1FlashLookup(list.map(function (x) { return x.handle; })).then(function (flash) {
        if (panel.classList.contains('open')) w1WishRender(panel, list, flash);
      });
    }
  };
  function w1WishInit() {
    w1WishBadge();
    var btn = document.querySelector('.wishbtn');
    if (btn && w1WishList().some(function (x) { return x.handle === btn.getAttribute('data-handle'); })) {
      btn.textContent = '♥';
    }
  }

  /* Size guide modal */
  window.w1SizeGuide = function () { var m = document.getElementById('w1SizeModal'); if (m) m.hidden = false; };
  window.w1SizeGuideClose = function () { var m = document.getElementById('w1SizeModal'); if (m) m.hidden = true; };
  window.w1SizeTab = function (btn, tab) {
    document.querySelectorAll('.smtabs .chip').forEach(function (c) { c.classList.remove('on'); });
    btn.classList.add('on');
    document.querySelectorAll('.smbody').forEach(function (b) { b.hidden = b.getAttribute('data-tab') !== tab; });
  };

  /* Also-bought via Shopify native recommendations. Hidden until the
     API returns pieces (drafts return none, lights up with the range). */
  function w1AlsoBought() {
    var grid = document.getElementById('w1AlsoBought');
    if (!grid) return;
    fetch('/recommendations/products.json?product_id=' + grid.getAttribute('data-product-id') + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) return;
        grid.hidden = false;
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '&width=600" alt="" width="600" height="800" loading="lazy" style="width:100%;height:100%;object-fit:cover">'
            : '<div class="shot-desc"><span class="shot-tag">Shot</span><p>' + p.title + '</p></div>';
          return '<a class="pcard" href="' + p.url + '" style="color:inherit;text-decoration:none;display:block">' +
            '<figure class="shot ar34 cbox">' + img + '</figure>' +
            '<div class="pc-info"><div class="pc-name">' + p.title + '</div>' +
            '<div class="pc-meta"><span class="pc-col"></span><span class="pc-price">A$' + (p.price / 100).toFixed(2) + '</span></div></div></a>';
        }).join('');
      })
      .catch(function () { /* recommendations warm up with sales data */ });
  }

  /* Taste quiz: four steps, saved to localStorage the moment the last
     step lands, synced to cart attributes so the answers ride into the
     order (Shopify Flow copies them to the customer metafield, the
     no-n8n path), and handed to Doud as context. */
  var QUIZ_KEYS = ['colours', 'fits', 'activities', 'who'];
  function w1QuizState() {
    try { return JSON.parse(localStorage.getItem('w1_taste') || 'null'); } catch (e) { return null; }
  }
  function w1QuizGather() {
    var out = {};
    QUIZ_KEYS.forEach(function (key, i) {
      out[key] = [...document.querySelectorAll('.qstep[data-step="' + i + '"] .qcard.on')].map(function (c) { return c.getAttribute('data-value'); });
    });
    return out;
  }
  window.w1QuizPick = function (el) {
    el.classList.toggle('on');
  };
  window.w1QuizStep = function (dir) {
    var quiz = document.getElementById('w1Quiz');
    if (!quiz) return;
    var step = parseInt(quiz.getAttribute('data-step'), 10) + dir;
    step = Math.max(0, Math.min(4, step));
    quiz.setAttribute('data-step', step);
    document.querySelectorAll('.qstep').forEach(function (s) { s.hidden = s.getAttribute('data-step') != step; });
    var back = document.getElementById('w1QuizBack');
    var next = document.getElementById('w1QuizNext');
    if (back) back.disabled = step === 0;
    if (next) next.style.display = step === 4 ? 'none' : '';
    var bar = document.getElementById('w1QuizBar');
    if (bar) bar.style.width = (step / 4 * 100) + '%';
    if (step === 4) w1QuizFinish();
  };
  function w1QuizFinish() {
    var taste = w1QuizGather();
    taste.saved_at = new Date().toISOString().slice(0, 10);
    try { localStorage.setItem('w1_taste', JSON.stringify(taste)); } catch (e) { /* private mode */ }
    var summary = document.getElementById('w1QuizSummary');
    if (summary) {
      var bits = [];
      if (taste.colours.length) bits.push(taste.colours.slice(0, 3).join(', ') + ' days');
      if (taste.fits.length) bits.push(taste.fits.slice(0, 2).join(' and ').toLowerCase() + ' fits');
      if (taste.activities.length) bits.push('built for ' + taste.activities.slice(0, 3).join(', ').toLowerCase());
      if (taste.who.length > 1) bits.push('shopping for ' + taste.who.length + ' of you');
      summary.textContent = bits.length ? 'So: ' + bits.join(', ') + '. The wardrobe is listening.' : 'A blank canvas, we can work with that too.';
    }
    /* ride the answers into the cart so Flow can file them on the customer */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { taste_quiz: JSON.stringify(taste) } })
    }).catch(function () { /* cart not touched yet, localStorage still holds it */ });
  }
  window.w1QuizReset = function () {
    try { localStorage.removeItem('w1_taste'); } catch (e) { /* private mode */ }
    document.querySelectorAll('.qcard.on').forEach(function (c) { c.classList.remove('on'); });
    var quiz = document.getElementById('w1Quiz');
    if (quiz) { quiz.setAttribute('data-step', '3'); w1QuizStep(-3); }
  };
  function w1QuizRestore() {
    var quiz = document.getElementById('w1Quiz');
    var saved = w1QuizState();
    if (!quiz || !saved) return;
    QUIZ_KEYS.forEach(function (key, i) {
      (saved[key] || []).forEach(function (v) {
        var card = document.querySelector('.qstep[data-step="' + i + '"] .qcard[data-value="' + CSS.escape(v) + '"]');
        if (card) card.classList.add('on');
      });
    });
  }

  /* Doud, wired to the proxy server when W1_DOUD_URL is configured.
     Without it (key not arrived, server down) the bubble keeps the
     launch note, nothing errors in front of a customer. Text only. */
  var doudHistory = [];
  window.w1ToggleDoud = function () { var d = document.getElementById('w1Doud'); if (d) d.classList.toggle('open'); };
  window.w1OpenDoud = function () { var d = document.getElementById('w1Doud'); if (d) d.classList.add('open'); };
  function w1DoudBubble(text, mine) {
    var body = document.getElementById('w1DoudBody');
    if (!body) return null;
    var el = document.createElement('div');
    el.className = 'msg';
    if (mine) el.style.cssText = 'background:#111111;color:#FFFFFF;border-radius:12px 12px 3px 12px;align-self:flex-end';
    el.textContent = text;
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
    return el;
  }
  window.w1DoudSay = function (q) {
    if (!q || !q.trim()) return;
    q = q.trim().slice(0, 2000);
    w1DoudBubble(q, true);
    doudHistory.push({ role: 'user', content: q });

    if (!window.W1_DOUD_URL) {
      w1DoudBubble('In the live store I answer that instantly, in your language, with links you can tap. The real me goes live with the store.');
      doudHistory.pop();
      return;
    }

    var typing = w1DoudBubble('…');
    fetch(window.W1_DOUD_URL.replace(/\/$/, '') + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: doudHistory.slice(-16), taste: (function () { try { return localStorage.getItem('w1_taste') || undefined; } catch (e) { return undefined; } })() })
    }).then(function (r) { return r.json(); }).then(function (data) {
      var text = data.reply || data.message || 'Give me one more go at that?';
      if (typing) typing.textContent = text;
      if (data.reply) {
        doudHistory.push({ role: 'assistant', content: data.reply });
      } else {
        doudHistory.pop();
      }
    }).catch(function () {
      if (typing) typing.textContent = 'Doud stepped away for a second. The Family inbox always answers, see Help & FAQ.';
      doudHistory.pop();
    });
  };

  /* Guided tour (Brief 4 M3): "New to WeAreOne Wardrobe?" spotlight
     walkthrough, our own overlay, no external service. Four dim panels
     leave a real hole over the target, so real clicks land on the real
     element and elementFromPoint at the target returns page content,
     never the overlay (the 2026-07-17 incident rule, by construction).
     Pressing the highlighted element closes the tour and lets the real
     behaviour run: the visitor chose to explore. Next / Skip on every
     bubble, Escape exits, desktop and 390 both. */
  var TOUR_STEPS = [
    { name: 'Shop', sel: ['#w1ShopBtn', '.nav-left .burger'],
      text: 'One menu, the whole wardrobe: the six worlds and every category. Press it and go anywhere.' },
    { name: 'The six worlds', sel: ['.worldbands'],
      text: 'Every part of life has its own shop. Press any band to step inside its world.' },
    { name: 'Wear It Together', sel: ['.mainnav a[href*="wear-it-together"]', '.bundle'],
      text: 'Matching sets for the whole tribe: The Duo, The Trio, The Family Pack. One maker, one parcel, a better price.' },
    { name: 'Scroll to explore', sel: [],
      text: 'The home page keeps going: sets, members, the FitnessApp, the drop. Scroll any time, the wardrobe follows.' },
    { name: 'The FitnessApp', sel: ['.mainnav a[href*="fitnessapp"]', '.appband'],
      text: 'Training that lives with the gear: plans, exercise videos, coaching. Press to see what it does, or keep touring.' },
    { name: 'Features', sel: ['.mainnav a[href*="features"]', '.nav-left .burger'],
      text: 'Match with me shows a piece on you before you buy. Your fit stays saved. Tell us your taste tunes the shop to you.',
      altText: 'Behind this menu: Features. Match with me shows a piece on you, your fit stays saved, Tell us your taste tunes the shop to you.' },
    { name: 'Sign in to get rewards', sel: ['.nav-right .signin'],
      text: 'Points on every dollar, one shared pool for the household, 10% off your first order. Press to join or sign in.' },
    { name: 'The heart', sel: ['.nav-right button[aria-label="Wishlist"]'],
      text: 'Your favourites wait here. Favourites get flash-sale alerts, so you hear first when a saved piece goes on sale.' },
    { name: 'Your bag', sel: ['a.cart'],
      text: 'One cart across all six worlds, one checkout at the end.' },
    { name: 'Languages', sel: ['button[aria-label="Languages"]'],
      text: 'English today, Français and 日本語 on the way.' },
    { name: 'Country', sel: ['button[aria-label="Country and currency"]'],
      text: 'Choose your location. Prices show in your currency.' },
    { name: 'Ask Doud', sel: ['#w1DoudFab'],
      text: 'Our guide knows every piece, size and set. Ask anything, day or night.' }
  ];
  var tour = { on: false, idx: 0, el: null, target: null, usedAlt: false, say: '' };

  function tourVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && window.getComputedStyle(el).visibility !== 'hidden';
  }
  function tourPick(step) {
    for (var i = 0; i < step.sel.length; i++) {
      var el = document.querySelector(step.sel[i]);
      if (tourVisible(el)) { tour.usedAlt = i > 0; return el; }
    }
    tour.usedAlt = false;
    return null;
  }
  function tourBuild() {
    if (tour.el) return;
    var root = document.createElement('div');
    root.className = 'w1 w1-tour';
    root.id = 'w1Tour';
    root.hidden = true;
    root.innerHTML =
      '<div class="w1-tour-dim" data-d="t"></div><div class="w1-tour-dim" data-d="b"></div>' +
      '<div class="w1-tour-dim" data-d="l"></div><div class="w1-tour-dim" data-d="r"></div>' +
      '<div class="w1-tour-ring"></div>' +
      '<div class="w1-tour-bubble" role="dialog" aria-label="Site tour" aria-live="polite">' +
      '<span class="tt-step"></span><b></b><p></p>' +
      '<div class="tt-row"><button class="btn sm accent tt-next" type="button">Next</button>' +
      '<button class="tt-skip" type="button">Skip the tour</button>' +
      '<button class="tt-sound" type="button" aria-pressed="false">Sound off</button></div></div>';
    document.body.appendChild(root);
    root.querySelector('.tt-next').addEventListener('click', function () { tourStep(tour.idx + 1); });
    root.querySelector('.tt-skip').addEventListener('click', function () { tourClose(false); });
    root.querySelector('.tt-sound').addEventListener('click', w1TourSound);
    /* the dim must never trap a real scroll: wheel passes through to the
       page (Horizon scrolls .page-wrapper on desktop, the window on phone) */
    root.addEventListener('wheel', function (e) {
      var pw = document.querySelector('.page-wrapper');
      if (pw && window.getComputedStyle(pw).overflowY !== 'visible') pw.scrollTop += e.deltaY;
      else window.scrollBy(0, e.deltaY);
    }, { passive: true });
    tour.el = root;
  }
  function tourRoots() {
    var pw = document.querySelector('.page-wrapper');
    return pw ? [window, pw] : [window];
  }
  function tourScrollTo(el) {
    if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function tourPosition() {
    if (!tour.on || !tour.el) return;
    var vw = window.innerWidth, vh = window.innerHeight, pad = 6;
    var dims = {
      t: tour.el.querySelector('[data-d="t"]'), b: tour.el.querySelector('[data-d="b"]'),
      l: tour.el.querySelector('[data-d="l"]'), r: tour.el.querySelector('[data-d="r"]')
    };
    var ring = tour.el.querySelector('.w1-tour-ring');
    var bub = tour.el.querySelector('.w1-tour-bubble');
    if (!tour.target) {
      dims.t.style.cssText = 'top:0;left:0;width:100%;height:100%';
      dims.b.style.cssText = dims.l.style.cssText = dims.r.style.cssText = 'width:0;height:0';
      ring.style.display = 'none';
      var bw = bub.offsetWidth, bh = bub.offsetHeight;
      /* Brief 6 M5: the bubble travels on transform, not top and left, so the
         move stays on the compositor (apple-design §11). */
      bub.style.transform = 'translate(' + Math.max(14, (vw - bw) / 2) + 'px,' + Math.max(14, (vh - bh) / 2) + 'px)';
      return;
    }
    var r = tour.target.getBoundingClientRect();
    var top = Math.max(0, r.top - pad), bottom = Math.min(vh, r.bottom + pad);
    var left = Math.max(0, r.left - pad), right = Math.min(vw, r.right + pad);
    dims.t.style.cssText = 'top:0;left:0;width:100%;height:' + top + 'px';
    dims.b.style.cssText = 'top:' + bottom + 'px;left:0;width:100%;height:' + Math.max(0, vh - bottom) + 'px';
    dims.l.style.cssText = 'top:' + top + 'px;left:0;width:' + left + 'px;height:' + Math.max(0, bottom - top) + 'px';
    dims.r.style.cssText = 'top:' + top + 'px;left:' + right + 'px;width:' + Math.max(0, vw - right) + 'px;height:' + Math.max(0, bottom - top) + 'px';
    ring.style.display = '';
    /* Brief 6 M5: the ring's position is a transform so it travels between steps
       on the compositor; top and left are pinned at 0 in the stylesheet. Its box
       still sizes with width and height, which are set, never transitioned. */
    ring.style.transform = 'translate(' + (left - 2) + 'px,' + (top - 2) + 'px)';
    ring.style.width = (right - left) + 'px';
    ring.style.height = (bottom - top) + 'px';
    var bw2 = bub.offsetWidth, bh2 = bub.offsetHeight;
    var bt = bottom + 14;
    if (bt + bh2 > vh - 14) bt = top - bh2 - 14;
    if (bt < 14) bt = Math.min(vh - bh2 - 14, Math.max(14, (vh - bh2) / 2));
    var bl = Math.min(Math.max(14, r.left), vw - bw2 - 14);
    bub.style.transform = 'translate(' + bl + 'px,' + bt + 'px)';
  }
  function tourStep(i) {
    if (i >= TOUR_STEPS.length) { tourClose(true); return; }
    tour.idx = i;
    var step = TOUR_STEPS[i];
    tour.target = step.sel.length ? tourPick(step) : null;
    if (step.sel.length && !tour.target) { tourStep(i + 1); return; }
    var bub = tour.el.querySelector('.w1-tour-bubble');
    bub.querySelector('.tt-step').textContent = 'Step ' + (i + 1) + ' of ' + TOUR_STEPS.length + ' · press it or press next';
    bub.querySelector('b').textContent = step.name;
    bub.querySelector('p').textContent = (tour.usedAlt && step.altText) ? step.altText : step.text;
    bub.querySelector('.tt-next').textContent = i === TOUR_STEPS.length - 1 ? 'Finish' : 'Next';
    if (step.name === 'Scroll to explore') {
      var roots = tourRoots();
      roots.forEach(function (root) {
        var el = root === window ? window : root;
        if (el.scrollBy) el.scrollBy({ top: Math.round(window.innerHeight * 0.5), behavior: 'smooth' });
      });
    } else if (tour.target) {
      tourScrollTo(tour.target);
    }
    tourPosition();
    w1TourSpeak(step.name + '. ' + ((tour.usedAlt && step.altText) ? step.altText : step.text));
    setTimeout(function () { var n = tour.el.querySelector('.tt-next'); if (n && tour.on) n.focus({ preventScroll: true }); }, 60);
  }
  function tourTick() {
    if (!tour.on) return;
    tourPosition();
    requestAnimationFrame(tourTick);
  }
  function tourDocClick(e) {
    if (!tour.on || !tour.target) return;
    if (tour.el.contains(e.target)) return;
    if (tour.target.contains(e.target)) tourClose(false, true);
  }
  function tourKey(e) {
    if (tour.on && e.key === 'Escape') tourClose(false);
  }
  window.w1TourStart = function () {
    if (!document.querySelector('.worldbands')) {
      window.location.href = '/?w1tour=1';
      return;
    }
    /* an open welcome pop-up would sit between the dim and the page and
       swallow the spotlight's real clicks: hide it, WITHOUT burning its
       once-per-browser flag (the visitor still gets the 10% offer later) */
    var wel = document.getElementById('w1Welcome');
    if (wel && !wel.hidden) {
      wel.classList.remove('open');
      wel.hidden = true;
    }
    tourBuild();
    tour.on = true;
    window.__w1TourActive = true;
    tour.el.hidden = false;
    tour.el.classList.add('w1-tour-running');   /* Brief 6 M5: will-change only while it runs */
    tourSoundPaint();
    document.addEventListener('click', tourDocClick, true);
    document.addEventListener('keydown', tourKey);
    tourStep(0);
    requestAnimationFrame(tourTick);
  };
  function tourClose(finished, quiet) {
    tour.on = false;
    window.__w1TourActive = false;
    if (tour.el) { tour.el.hidden = true; tour.el.classList.remove('w1-tour-running'); }
    document.removeEventListener('click', tourDocClick, true);
    document.removeEventListener('keydown', tourKey);
    w1TourSpeak('');
    if (finished) window.w1Toast('That is the tour. Doud has the answers whenever you need one.');
    else if (!quiet) window.w1Toast('Tour closed. Restart it any time from the Shop menu.');
  }
  /* Tour sound (M4): the browser's own SpeechSynthesis, no audio files,
     no external TTS. Behaviour verified against current docs 2026-07-18:
     Chrome (M71+) fires not-allowed on speak() unless the frame has had
     user activation; Safari, iOS especially, silently drops utterances
     outside a user gesture handler. Both are satisfied by design: sound
     is OFF by default, only a tap turns it on, and every speak runs
     inside a click handler (the toggle or Next). Choice remembered for
     the session only (sessionStorage). The utterance is held in a var
     because Safari can garbage-collect a speaking utterance. */
  var tourUtter = null;
  function tourSoundOn() {
    try { return sessionStorage.getItem('w1_tour_sound') === '1'; } catch (e) { return false; }
  }
  function tourSoundPaint() {
    if (!tour.el) return;
    var b = tour.el.querySelector('.tt-sound');
    var on = tourSoundOn();
    b.textContent = on ? 'Sound on' : 'Sound off';
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  window.w1TourSound = function () {
    var on = !tourSoundOn();
    try { sessionStorage.setItem('w1_tour_sound', on ? '1' : '0'); } catch (e) { /* private mode */ }
    tourSoundPaint();
    if (on) w1TourSpeak(tour.say); /* this tap is the user gesture */
    else if (window.speechSynthesis) window.speechSynthesis.cancel();
  };
  function w1TourSpeak(text) {
    if (text) tour.say = text;
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    if (!text || !tour.on || !tourSoundOn()) return;
    try {
      tourUtter = new SpeechSynthesisUtterance(text);
      tourUtter.lang = 'en-AU';
      tourUtter.rate = 1;
      window.speechSynthesis.speak(tourUtter);
    } catch (e) { /* engine unavailable: the bubble text carries the tour */ }
  }

  /* Flash-sale clock (Brief 4 M5): every [data-flash-until] face is
     validated against the real clock, unhidden while the window is
     live, ticked every 30 seconds, and folded away the moment it ends
     (any Sale/New badge parked behind it comes back). */
  function w1FlashWords(ms) {
    var m = Math.floor(ms / 6e4);
    var d = Math.floor(m / 1440);
    var h = Math.floor((m % 1440) / 60);
    var mm = m % 60;
    if (d > 0) return 'Ends in ' + d + 'd ' + h + 'h';
    if (h > 0) return 'Ends in ' + h + 'h ' + mm + 'm';
    return 'Ends in ' + Math.max(1, mm) + 'm';
  }
  function w1FlashTick() {
    var els = document.querySelectorAll('[data-flash-until]');
    if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-flash-until'));
      var live = !isNaN(t) && t > now;
      el.hidden = !live;
      var scope = el.closest('.pcard-live, .pdp-info') || null;
      if (scope) {
        scope.querySelectorAll('[data-flash-badge]').forEach(function (b) { b.hidden = !live; });
        scope.querySelectorAll('[data-flash-other]').forEach(function (b) { b.hidden = live; });
      }
      if (live) {
        var txt = el.querySelector('[data-flash-text]');
        if (txt) txt.textContent = w1FlashWords(t - now);
      }
    });
  }
  setInterval(w1FlashTick, 30000);

  /* countdown, drop live AU midnight 30 October 2026 */
  function w1TickDrop() {
    var target = new Date('2026-10-30T00:00:00+11:00').getTime();
    var diff = Math.max(0, target - Date.now());
    var d = Math.floor(diff / 864e5); diff -= d * 864e5;
    var h = Math.floor(diff / 36e5); diff -= h * 36e5;
    var m = Math.floor(diff / 6e4);
    var set = function (cls, v) {
      document.querySelectorAll('.' + cls).forEach(function (e) { e.textContent = String(v).padStart(2, '0'); });
    };
    set('cd-d', d); set('cd-h', h); set('cd-m', m);
    var mc = document.getElementById('w1MegaCount');
    if (mc) mc.textContent = d + ' days to the drop';
  }
  setInterval(w1TickDrop, 30000);

  /* click-outside closers */
  document.addEventListener('click', function (e) {
    var m = document.getElementById('w1Mega');
    if (m && m.classList.contains('open') && !e.target.closest('#w1Mega') && !e.target.closest('#w1ShopBtn')) window.w1CloseMega();
    var lp = document.getElementById('w1LangPanel');
    if (lp && lp.classList.contains('open') && !e.target.closest('#w1LangPanel') && !e.target.closest('.langbtn')) lp.classList.remove('open');
    var cp = document.getElementById('w1CountryPanel');
    if (cp && cp.classList.contains('open') && !e.target.closest('#w1CountryPanel') && !e.target.closest('.langbtn')) cp.classList.remove('open');
    var wp = document.getElementById('w1WishPanel');
    if (wp && wp.classList.contains('open') && !e.target.closest('#w1WishPanel')) wp.classList.remove('open');
    var dd = document.getElementById('w1Doud');
    if (dd && dd.classList.contains('open') && !e.target.closest('#w1Doud') && !e.target.closest('#w1DoudFab')) dd.classList.remove('open');
  });

  function w1Boot() {
    w1TickDrop();
    w1WireAtc();
    w1SyncVariant();
    w1RestorePriceBand();
    w1WelcomeInit();
    w1QuizRestore();
    w1WishInit();
    w1AlsoBought();
    w1FlashTick();
    /* tour handoff from other pages: /?w1tour=1 starts it on the home page */
    if (new URLSearchParams(window.location.search).get('w1tour') === '1' && document.querySelector('.worldbands')) {
      setTimeout(window.w1TourStart, 700);
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.w1CloseSearch();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', w1Boot);
  } else {
    w1Boot();
  }
})();
